module.exports = __webpack_public_path__ + "static/media/alertWpp.0dedb969.svg";